import Hero from "../sections/Hero";
import TrustBar from "../sections/TrustBar";
import SymptomSearch from "../sections/SymptomSearch";
import MeetDoctor from "../sections/MeetDoctor";
import AdvancedProcedures from "../sections/AdvancedProcedures";
import ConditionsTreated from "../sections/ConditionsTreated";
import VideoKnowledgeCenter from "../sections/VideoKnowledgeCenter";
import PatientReviews from "../sections/PatientReviews";
import Locations from "../sections/Locations";
import FAQSection from "../sections/FAQSection";
import SEO from "../seo/SEO";
import {
  physicianSchema,
  medicalClinicSchemas,
  faqPageSchema,
  breadcrumbSchema,
  webPageSchema,
} from "../seo/schemas";
import { FAQS } from "../data/site";

export default function Home() {
  return (
    <main data-testid="home-page">
      <SEO
        title="Dr. Indresh Dixit — Best Gastroenterologist & Liver Specialist in Varanasi"
        description="Dr. Indresh Dixit — DM Gastroenterology (BHU). Advanced gastro, liver and endoscopy care in Varanasi. Lanka & Chetganj clinics. 900+ Google reviews, 4.8 rating."
        canonical="/"
        schemas={[
          physicianSchema(),
          ...medicalClinicSchemas(),
          webPageSchema({
            name: "Dr. Indresh Dixit — Gastroenterologist in Varanasi",
            description:
              "Advanced gastroenterology, hepatology and endoscopy practice in Varanasi.",
            url: "/",
          }),
          faqPageSchema(FAQS),
          breadcrumbSchema([{ label: "Home", url: "/" }]),
        ]}
      />
      <Hero />
      <TrustBar />
      <SymptomSearch headingTag="h2" />
      <MeetDoctor headingTag="h2" />
      <AdvancedProcedures headingTag="h3" />
      <ConditionsTreated headingTag="h2" />
      <VideoKnowledgeCenter headingTag="h3" />
      <PatientReviews headingTag="h3" />
      <Locations headingTag="h3" />
      <FAQSection headingTag="h2" />
    </main>
  );
}
